import {
  INK_CHAIN_ID,
  type NadoWithdrawalSourceOption,
} from '@funkit/connect-core/clients/nado'
import type { Address } from 'viem'

/** Row identity, routing and logs. */
export const NADO_METHOD_ID = 'nado'

/**
 * Sent explicitly on every call: Nado treats an absent `spot_leverage` as
 * `true`, so omitting it would open a margin position for a user with no
 * affordance to see or close one.
 */
export const NADO_MOBILE_SPOT_LEVERAGE = false

/**
 * Below this the sequencer fee and routing costs eat most of the withdrawal.
 * Token units, calibrated for USDT0 — the only source mobile ships.
 */
export const NADO_MIN_WITHDRAWAL_TOKENS = 4

/**
 * The only source mobile withdraws. Web has the integrator declare the whole
 * product table because it offers every listing; mobile ships the one it
 * supports rather than making every host restate Nado's ids.
 */
export const NADO_USDT0_SOURCE_TOKEN: NadoWithdrawalSourceOption = {
  productId: 0,
  symbol: 'USDT0',
  decimals: 6,
  tokenAddress: '0x0200C29006150606B650577BBE7B6248F58470c1',
  tokenChainId: `${INK_CHAIN_ID}`,
  iconSrc: undefined,
}

/**
 * Nado withdrawal, as the host configures it. Mirrors web's
 * `NadoWithdrawalConfig` where the concepts overlap, minus the borrow toggle and
 * the multi-product picker.
 */
export interface NadoWithdrawalFlowConfig {
  /** Must also be the signer — Nado rejects linked signers on withdrawals. */
  walletAddress: Address
  /** Omit for the default subaccount. Packed with the wallet; capped at 12 bytes. */
  subaccountName?: string
  /**
   * Awaited after the user taps Withdraw, before anything is minted or signed.
   * Throw to abort.
   */
  onBeforeSign?: () => Promise<void> | void
}
